import {makeAutoObservable} from 'mobx'

const APP_KEY = 'website-mobile-live'

function getItem(key) {
    const appJson = sessionStorage.getItem(APP_KEY)

    if (!appJson) {
        return null;
    }

    let app = JSON.parse(appJson)
    return app[key]
}

function setItem(key, value) {
    const appJson = sessionStorage.getItem(APP_KEY)
    let app
    if (!appJson) {
        app = {}
    } else {
        app = JSON.parse(appJson)
    }

    app = {...app, [key]: value}

    sessionStorage.setItem(APP_KEY, JSON.stringify(app))
}

class AppStore {
    tab = '/home'
    clientWidth = document.documentElement.getBoundingClientRect().width
    clientHeight = document.documentElement.getBoundingClientRect().height
    // token = ''
    fontSize = 0

    constructor() {
        makeAutoObservable(this)
        // let token = getItem('token')
        // if (token) {
        //     this.token = token
        // }
    }


    // get token() {
    //     if (!this.token) {
    //         this.token = getItem('token');
    //     }
    //
    //     return this.token
    // }
    //
    // set token(value) {
    //     this.token = value
    //     setItem('token', value)
    // }

    get currentTab() {
        return this.tab
    }

    // get hasLogin() {
    //     return !!this.token;
    // }

    initFontSize(size) {
        this.fontSize = size
    }

    setTab = (tabName = '/home') => {
        this.tab = tabName
    }
}

const store = new AppStore()

export default store
